var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightEstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.81827 7.09089H1.63645V12.5454H3.27282V7.09089H6.00009V12.5454H7.63646V7.09089H10.3637V12.5454H12.0001V7.09089H14.7274V12.5454H16.3637V7.09089H17.1819C17.5424 7.09089 17.8605 6.85487 17.965 6.50981C18.0694 6.16476 17.9357 5.79194 17.6357 5.59192L9.45392 0.137373C9.17912 -0.0457909 8.82102 -0.0457909 8.54622 0.137373L0.364396 5.59192C0.0643961 5.79194 -0.069295 6.16476 0.0351597 6.50981C0.139669 6.85487 0.457778 7.09089 0.81827 7.09089Z",
    fill: "#565656",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.182 14.1816H16.3638H14.7274H12.0001H10.3638H7.63649H6.00013H3.27285H1.63649H0.818305C0.36645 14.1816 0.00012207 14.548 0.00012207 14.9998V17.1816C0.00012207 17.6335 0.36645 17.9998 0.818305 17.9998H17.182C17.6338 17.9998 18.0001 17.6335 18.0001 17.1816V14.9998C18.0001 14.548 17.6338 14.1816 17.182 14.1816Z",
    fill: "#565656",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightEstate);
export default __webpack_public_path__ + "static/media/light-estate.0f1a85b4.svg";
export { ForwardRef as ReactComponent };